import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoadingSpinner } from '../../../components/Loading/LoadingSpinner';
import { confirmTossPayment } from '../../../api/utils/api/purchaseApi';

/**
 * 토스 결제 성공 페이지
 * @description 토스 결제 성공 시 해당 페이지로 리다이렉션함
 */
const PurchaseSuccess = () => {
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const paymentKey = query.get('paymentKey');
  const orderId = query.get('orderId');
  const amount = query.get('amount');

  /** params 없으면 결제 실패 페이지로 리다이렉트 */
  useEffect(() => {
    if (!paymentKey || !orderId || !amount) {
      navigate(
        '/commerce/purchase/fail?code=INVALID_PARAMS&message=' +
          encodeURIComponent('잘못된 접근입니다.'),
        { replace: true },
      );
      return;
    }

    /** 토스 결제 승인 요청 */
    confirmTossPayment({
      paymentKey,
      orderId,
      amount: Number(amount),
    })
      .then((response) => {
        if (response.resCd !== '0000') {
          // 결제 승인 실패 처리 (API 성공, 비즈니스 로직 실패)
          navigate(
            `/commerce/purchase/fail?code=${response.resCd}&message=${encodeURIComponent(response.resMsg)}`,
          );
        } else {
          // 승인 성공 (resCd=0000)
          /** case1. 카드/실시간 계좌이체 결제 시 리다이렉트 */
          if (response.redirectUrl) {
            const { pathname, search } = new URL(response.redirectUrl);
            navigate(pathname + search, { replace: true });
          } else {
            /** case2. 가상계좌 결제 시 완료 페이지로 이동 리다이렉트 (orderMasterId 전달) */
            navigate(`/commerce/purchase/staging?res=y&mst_id=${orderId}`, {
              replace: true,
            });
          }
        }
      })
      .catch((error) => {
        // 결제 승인 api 에러 처리 (네트워크/서버 오류)
        const message =
          error?.response?.data?.message ?? '결제 승인 중 오류가 발생했습니다';
        const code = error?.response?.data?.code ?? 'UNKNOWN';
        navigate(
          `/commerce/purchase/fail?code=${code}&message=${encodeURIComponent(message)}`,
          { replace: true },
        );
      });
  }, []);

  return (
    <div className="fixed left-0 top-0 flex h-full w-full justify-center bg-gray2 opacity-80">
      <div className="mx-auto flex w-fit flex-col items-center justify-center gap-5 py-10">
        <LoadingSpinner />
        <div className="text-center text-sm text-gray-800">
          결제 진행중입니다
        </div>
        <div className="text-center text-xs text-gray-600">승인 처리중</div>
      </div>
    </div>
  );
};

export default PurchaseSuccess;
